import Modal from "@flame-ui/core/src/content/modal/Modal";
import styled from "styled-components";

export const ModalContainer = styled(Modal)``;

export const TextoModal = styled.div`
  overflow-y: hidden;
`;
